/**
 * The training course (08 §4 "interactive field manual"; ROUND7 §5): standard issue, the three fixed pods and
 * a ghillie wrap to learn with. Like Practice, nothing is recorded and nothing is at stake.
 *
 * ROUND7 CONTRACT: TRAINING owns this file and may change the kit; `params` only names the course for the
 * replay and the music - the map itself is hand-built (`src/gen/training`), never generated from them.
 */

import type { MissionParams } from '../sim/types';
import type { Deployment } from './api';
import { FIXED_POD, STANDARD_ISSUE } from './content/economy';

export const TRAINING_PARAMS: MissionParams = {
  archetype: 'munitions-depot', biome: 'temperate', timeOfDay: 'day', weather: 'clear',
  threat: 1, seed: 1987, modifiers: [], intel: [],
};

export function trainingDeployment(): Deployment {
  return {
    params: { ...TRAINING_PARAMS, modifiers: [], intel: [] },
    rangerId: 'training',
    loadout: {
      carried: { ...STANDARD_ISSUE },
      pods: [{ ...FIXED_POD }, { ...FIXED_POD }, { ...FIXED_POD }],
      gear: { ghillie: true },
    },
    mods: {},
    mode: 'training',
  };
}
